import { Component } from '@angular/core'
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  template: `
    <div class="footer">
      <div class="card clearfix">
        <span class="footer-text-left">
          <b> Copyright © {{ copyrightDate }}</b
          >,
        </span>
        <span class="footer-text-right">
          <span class="material-icons ui-icon-copyright"></span>
          <span
            >All rights reserved. <b>| </b>
            <a
              href="https://medtechsolutions.com/legal/privacy-policy/"
              target="_blank"
              title="View Privacy Policy"
            >
              <b>Privacy Policy </b>
            </a></span
          >
        </span>
      </div>
    </div>
  `,
})
export class AppFooterComponent {
    copyrightDate: string = environment.copyrightDate;
    //localStorage.getItem('copyrightDate') != null
    //  ? localStorage.getItem('copyrightDate')
    //  : '2017-2024 eMedApps Inc'
}
